<template>
  <div class="modal-mask" @click.self="fechar">
    <div class="modal-wrapper">
      <div class="modal-container">

        <div class="modal-header">
          <h3>Respostas de: {{ servidor.nome }}</h3>
          <button @click="fechar" class="close-button">&times;</button>
        </div>

        <div class="modal-body">
          <div v-if="carregando">Carregando respostas...</div>
          <div v-else-if="erro">{{ erro }}</div>
          <ul v-else>
            <li v-for="(resposta, index) in respostas" :key="index" class="resposta-item">
              <p><strong>{{ resposta.pergunta }}</strong></p>
              <span>{{ resposta.resposta || 'Não respondido' }}</span>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import FormularioApi from '../../services/FormularioApi';

export default {
  name: "VisualizarRespostasModal",
  props: {
    servidor: { type: Object, required: true },
    formularioId: { type: [String, Number], required: true },
  },
  data() {
    return {
      carregando: true,
      respostas: [],
      erro: null,
    };
  },
  created() {
    this.formularioApi = new FormularioApi();
    this.carregarRespostas();
  },
  methods: {
    async carregarRespostas() {
      this.carregando = true;
      this.erro = null;
      try {
        const data = await this.formularioApi.getRespostasPorServidor(this.formularioId, this.servidor.id);
        this.respostas = data.respostas;
      } catch (err) {
        console.error("Erro ao buscar respostas do servidor:", err);
        this.erro = "Não foi possível carregar as respostas.";
      } finally {
        this.carregando = false;
      }
    },
    fechar() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
/* --- ESTILOS ATUALIZADOS --- */

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

/* 1. Modal um pouco maior */
.modal-container {
  width: 800px;
  max-width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0;
  color: #005516;
  border-bottom: 2px solid #f0f0f0; /* Borda um pouco mais grossa */
  padding-bottom: 15px;
}

/* 2. Fonte do título ajustada */
.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
}

.modal-body {
  margin: 25px 0;
  max-height: 60vh;
  overflow-y: auto;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem; /* Botão de fechar menor */
  line-height: 1;
  cursor: pointer;
  color: #aaa;
  padding: 0;
}
.close-button:hover {
  color: #333;
}

ul {
  list-style: none;
  padding: 0;
}

/* 3. Mais organização na lista de pergunta/resposta */
.resposta-item {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f0f0f0;
}
.resposta-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

/* Fonte da pergunta ajustada */
.resposta-item p {
  margin: 0;
  font-size: 1rem;
  color: #333;
}

/* Fonte e organização da resposta ajustados */
.resposta-item span {
  display: block;
  margin-top: 0.5rem;
  padding-left: 1rem; /* Adiciona uma indentação para organizar */
  font-size: 0.95rem;
  color: #555;
  font-style: italic;
}
</style>